import { NavigateFunction } from 'react-router-dom';

/** If path is absolute (admin host), use location.assign; else react-router navigate. */
export function navigateAppOrExternal(
  navigate: NavigateFunction,
  path: string,
  options?: { replace?: boolean }
): void {
  if (/^https?:\/\//i.test(path)) {
    window.location.assign(path);
    return;
  }
  navigate(path, { replace: options?.replace });
}
